(function ($) {
  DJ.addBehavior('CocoenSlider', '.cocoen', {
    attach: function (context, settings) {
      Cocoen.parse(document.body);
    },
    detach: function (context, settings) {}
  });
})(jQuery);
